export const API_CALL = 'API_CALL';

export const REQUEST_ORDER = 'ORDER:REQUEST:GET_BY_ID';
export const RECEIVE_ORDER = 'ORDER:RESPONSE:GET_OR_SAVE';
export const SAVE_ORDER = 'ORDER:REQUEST:SAVE';
export const ORDER_FAILED = 'ORDER:RESPONSE:FAIL';
export const REQUEST_CLONE_ORDER = "ORDER:REQUEST:CLONE";
export const RECEIVE_CLONE_ORDER = "ORDER:RESPONSE:CLONE";
export const CLONE_ORDER_FAILED = "ORDER:RESPONSE:CLONE:FAIL";
export const RESET_CLONE_STATE = "ORDER:CLONE:RESET";
export const ADD_PLACEMENTS_TO_ORDER = 'ORDER:ADD_PLACEMENTS';
export const UPDATE_PLACEMENTS_IN_ORDER = 'ORDER:UPDATE_PLACEMENTS';
export const ADD_OR_UPDATE_PLACEMENTS_IN_ORDER = 'ORDER:ADD_OR_UPDATE_PLACEMENTS';
export const DELETE_ORDER = 'ORDER:REQUEST:DELETE';
export const RECEIVE_DELETED_ORDER = 'ORDER:RESPONSE:DELETE';
export const UPDATE_INLINE_PLACEMENT = 'ORDER:REQUEST:UPDATE_PLACEMENT';

export const SELECT_ATTACHMENT = 'SELECT_ATTACHMENT';
export const UPLOAD_ATTACHMENT = 'UPLOAD_ATTACHMENT';
export const RECEIVE_ATTACHMENT = 'RECEIVE_ATTACHMENT';
export const ATTACHMENT_UPLOAD_FAILED = 'ATTACHMENT_UPLOAD_FAILED';
export const LIST_ATTACHMENTS = 'LIST_ATTACHMENTS';
export const RECEIVE_ATTACHMENTS = 'RECEIVE_ATTACHMENTS';
export const LIST_ATTACHMENTS_FAILED = 'LIST_ATTACHMENTS_FAILED';
export const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT';
export const ATTACHMENT_DELETED = 'ATTACHMENT_DELETED';

export const REQUEST_PUSH_ORDER = 'ORDER:REQUEST:PUSH';
export const RECEIVE_PUSH_ORDER = 'ORDER:RECEIVE:PUSH';
export const PUSH_ORDER_FAILED = 'PUSH_ORDER_FAILED';
export const REQUEST_PUT_ORDER = 'ORDER:REQUEST:PUT';
export const RECEIVE_PUT_ORDER = 'ORDER:RECEIVE:PUT';
export const PUT_ORDER_FAILED = 'PUT_ORDER_FAILED';
export const REQUEST_UNLOCK_ORDER = 'ORDER:REQUEST:UNLOCK';
export const RECEIVE_UNLOCK_ORDER = 'ORDER:RECEIVE:UNLOCK';
export const UNLOCK_ORDER_FAILED = 'UNLOCK_ORDER_FAILED';

export const REQUEST_ADVERTISER_WITH_ORDERS = 'ADVERTISER:REQUEST:WITH_ORDERS';
export const RECEIVE_ADVERTISER_WITH_ORDERS = 'ADVERTISER:RESPONSE:WITH_ORDERS';
export const ADVERTISER_WITH_ORDERS_FAILED = 'ADVERTISER:RESPONSE:WITH_ORDERS_FAIL';

export const REQUEST_ADVERTISERS = 'ADVERTISERS:REQUEST:ALL';
export const RECEIVE_ADVERTISERS = 'ADVERTISERS:RESPONSE:ALL';
export const REQUEST_UPDATE_ADVERTISERS = 'ADVERTISER:REQUEST:UPDATE';
export const RECEIVE_UPDATE_ADVERTISERS = 'ADVERTISER:RESPONSE:UPDATE';
export const ADVERTISERS_FAILED =  'ADVERTISERS:RESPONSE:ALL_FAIL';

export const REQUEST_BUYERS = 'BUYERS:REQUEST:ALL';
export const RECEIVE_BUYERS = 'BUYERS:RESPONSE:ALL';
export const BUYERS_FAILED =  'BUYERS:RESPONSE:ALL_FAIL';

export const REQUEST_PLACEMENT = 'PLACEMENT:REQUEST:GET_BY_ID';
export const RECEIVE_PLACEMENT = 'PLACEMENT:RESPONSE:GET_BY_ID';
export const UPDATE_PLACEMENT = 'PLACEMENT:REQUEST:UPDATE';
export const PLACEMENT_UPDATED = 'PLACEMENT:RESPONSE:UPDATE';
export const PLACEMENT_FAILED = 'PLACEMENT:RESPONSE:FAIL';
export const SET_EDIT_PLACEMENTS = 'PLACEMENT:SET_EDIT_LIST';
export const GO_TO_PLACEMENT = 'PLACEMENT:GO_TO';
export const BEGIN_NEW_PLACEMENT = 'BEGIN_NEW_PLACEMENT';
export const DELETE_PLACEMENTS = 'PLACEMENTS:REQUEST:DELETE';
export const RECEIVE_DELETED_PLACEMENTS = 'PLACEMENTS:RESPONSE:DELETE';
export const DELETE_PLACEMENT = 'PLACEMENT:REQUEST:DELETE';
export const RECEIVE_DELETED_PLACEMENT = 'PLACEMENT:RESPONSE:DELETE';
export const CANCEL_PLACEMENT = 'PLACEMENT:REQUEST:CANCEL';
export const CANCEL_PLACEMENTS = 'PLACEMENTS:REQUEST:CANCEL';
export const RECEIVE_CANCEL = 'PLACEMENT:RESPONSE:CANCEL';
export const COPY_SETTINGS = 'PLACEMENT:REQUEST:COPY_SETTINGS';
export const RECEIVE_COPIED_SETTINGS = 'PLACEMENT:RESPONSE:COPY_SETTINGS';
export const COPY_SETTINGS_FAILED = 'PLACEMENT:RESPONSE:COPY_SETTINGS:FAIL';

export const REQUEST_CLONE_PLACEMENTS = 'PLACEMENTS:REQUEST:CLONE';
export const RECEIVE_CLONE_PLACEMENTS = 'PLACEMENTS:RECEIVE:CLONE';
export const CLONE_PLACEMENTS_FAILED = 'PLACEMENTS:CLONE:FAILED';
export const RESET_CLONE_PLACEMENT_STATE = 'RESET_CLONE_PLACEMENT_STATE';

export const REQUEST_CLONE_PLACEMENT = 'PLACEMENT:CLONE:REQUEST';
export const RECEIVE_CLONE_PLACEMENT = 'PLACEMENT:CLONE:RECEIVE';
export const CLONE_PLACEMENT_FAILED = 'CLONE_PLACEMENT_FAILED';

export const REQUEST_PUSH_PLACEMENTS = 'PLACEMENTS:PUSH:REQUEST';
export const RECEIVE_PUSH_PLACEMENTS = 'PLACEMENTS:PUSH:RECEIVE';
export const PUSH_FAILED = 'PUSH_FAILED';

//fix jobs from admin screen
export const REQUEST_FIX_PLACEMENTS = 'PLACEMENTS:FIX:REQUEST';
export const RECEIVE_FIX_PLACEMENTS = 'PLACEMENTS:FIX:RECEIVE';
export const FIX_FAILED = 'FIX_FAILED';
// proposal actions: request buyer acceptance, reopen proposal, change buyer
export const REQUEST_ACCEPT = 'ACCEPT:REQUEST';
export const RECEIVE_ACCEPT = 'ACCEPT:RECEIVE';
export const ACCEPT_FAILED = 'ACCEPT_FAILED';

export const REQUEST_REOPEN = 'REOPEN:REQUEST';
export const RECEIVE_REOPEN = 'REOPEN:RECEIVE';
export const REOPEN_FAILED = 'REOPEN_FAILED';

export const REQUEST_NEWBUYER = 'NEWBUYER:REQUEST';
export const RECEIVE_NEWBUYER = 'NEWBUYER:RECEIVE';
export const NEWBUYER_FAILED = 'NEWBUYER_FAILED';

export const REQUEST_CONST = 'CONST:REQUEST';
export const RECEIVE_CONST = 'CONST:RECEIVE';
export const CONST_FAILED = 'CONST_FAILED';

export const REQUEST_STRAT = 'STRATEGIES:REQUEST:ALL';
export const RECEIVE_STRAT = 'STRATEGIES:RESPONSE:ALL';
export const STRAT_FAILED = 'STRATEGIES:RESPONSE:ALL_FAIL';

// creative products, also by sales product
export const REQUEST_CP = 'CREATIVE_PRODUCTS:REQUEST:ALL';
export const RECEIVE_CP = 'CREATIVE_PRODUCTS:RESPONSE:ALL';
export const CP_FAILED = 'CREATIVE_PRODUCTS:RESPONSE:ALL_FAIL';
export const REQUEST_SPCP = 'CREATIVE_PRODUCTS:REQUEST:LOOKUP_BY_SALES_PRODUCT';
export const RECEIVE_SPCP = 'CREATIVE_PRODUCTS:RESPONSE:LOOKUP_BY_SALES_PRODUCT';
export const SPCP_FAILED = 'CREATIVE_PRODUCTS:RESPONSE:LOOKUP_FAIL';

// custom criteria presets
export const REQUEST_CCP = 'CUSTOM_CRITERIA_PRESETS:REQUEST:ALL';
export const RECEIVE_CCP = 'CUSTOM_CRITERIA_PRESETS:RESPONSE:ALL';
export const CCP_FAILED = 'CUSTOM_CRITERIA_PRESETS:RESPONSE:ALL_FAIL';

// third party targeting
export const REQUEST_TPT = 'TPT:REQUEST:ALL';
export const RECEIVE_TPT = 'TPT:RESPONSE:ALL';
export const TPT_FAILED = 'TPT:RESPONSE:ALL_FAIL';

// sales products
export const REQUEST_SP = 'SALES_PRODUCTS:REQUEST:LOOKUP_BY_STRATEGY';
export const RECEIVE_SP = 'SALES_PRODUCTS:RESPONSE:LOOKUP_BY_STRATEGY';
export const SP_FAILED = 'SALES_PRODUCTS:RESPONSE:LOOKUP_FAIL';

// device types
export const REQUEST_DEVICES = 'DEVICE_TYPES:REQUEST:ALL';
export const RECEIVE_DEVICES = 'DEVICE_TYPES:RESPONSE:ALL';
export const DEVICES_FAILED = 'DEVICE_TYPES:RESPONSE:ALL_FAIL';

// geotargets
export const REQUEST_GEO_QUERY = 'GEOTARGETS:REQUEST:BY_QUERY';
export const RECEIVE_GEO_QUERY = 'GEOTARGETS:RESPONSE:BY_QUERY';
export const GEO_FAILED = 'GEOTARGETS:RESPONSE:FAIL';
export const UPLOAD_GEOGROUPS = 'UPLOAD_GEOGROUPS';
export const UPLOAD_GEOGROUPS_RESULT = 'UPLOAD_GEOGROUPS_RESULT';
export const UPLOAD_GEOGROUPS_FAILED = 'UPLOAD_GEOGROUPS_FAILED';

export const START_INDEX_JOB = 'START_INDEX_JOB';
export const RECEIVE_INDEX_JOB_RESULTS = 'RECEIVE_INDEX_JOB_RESULTS';
export const INDEX_JOB_FAILED = 'INDEX_JOB_FAILED';

// search
export const START_SEARCH = 'SEARCH:REQUEST';
export const RECEIVE_SEARCH_RESULTS = 'SEARCH:RESULTS';
export const SEARCH_FAILED = 'SEARCH:FAIL';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';

// elastic search
export const START_ES_SEARCH = 'ES_SEARCH:REQUEST';
export const RECEIVE_ES_SEARCH_RESULTS = 'ES_SEARCH:RESULTS';
export const ES_SEARCH_FAILED = 'ES_SEARCH:FAIL';

// auth
export const SIGNIN = 'SIGNIN';
export const SIGNOUT = 'SIGNOUT';
export const SAVE_USER = 'SAVE_USER';
export const REQUEST_USER_PROFILE = 'REQUEST_USER_PROFILE';

export const REQUEST_CHANGELOG = 'ORDER:CHANGELOG:REQUEST';
export const RECEIVE_CHANGELOG = 'ORDER:CHANGELOG:RECEIVE';
export const CHANGELOG_FAILED = 'ORDER:CHANGELOG:FAIL';

export const START_BUYERS_SEARCH = 'BUYERS:SEARCH:REQUEST';
export const RECEIVE_BUYERS_SEARCH_RESULTS = 'BUYERS:SEARCH:RESULTS';
export const BUYERS_SEARCH_FAILED = 'BUYERS:SEARCH:FAIL';

export const REQUEST_UPLOAD = 'REQUEST_UPLOAD'
export const RECEIVE_UPLOAD = 'RECEIVE_UPLOAD'
export const UPLOAD_FAILED = 'UPLOAD_FAILED'

export const UPDATE_PACKAGE = 'UPDATE_PACKAGE'
export const PACKAGE_FAILED = 'PACKAGE_FAILED'
export const ADD_OR_UPDATE_PACKAGES_IN_ORDER = 'UPDATE_PACKAGES_IN_ORDER'
export const BEGIN_NEW_PACKAGE = 'BEGIN_NEW_PACKAGE'
export const RECEIVE_PACKAGE = 'RECEIVE_PACKAGE'

export const REQUEST_UPDATE_DELIVERY = 'REQUEST_UPDATE_DELIVERY'
export const RECEIVE_UPDATE_DELIVERY = 'RECEIVE_UPDATE_DELIVERY'
export const DELIVERY_FAILED = 'DELIVERY_FAILED'

export const REQUEST_CLONE_PACKAGE = 'REQUEST_CLONE_PACKAGE'
export const ADD_PACKAGES_TO_ORDER = 'ADD_PACKAGES_TO_ORDER'
export const CLONE_PACKAGE_FAILED = 'CLONE_PACKAGE_FAILED'

export const DELETE_PACKAGE = 'DELETE_PACKAGE'
export const RECEIVE_DELETED_PACKAGE = 'RECEIVE_DELETED_PACKAGE'

export const REQUEST_PUSH_PACKAGES = 'REQUEST_PUSH_PACKAGES'
export const RECEIVE_PUSH_PACKAGES = 'RECEIVE_PUSH_PACKAGES'

// preferences
export const SHOW_PREFERENCES = "SHOW_PREFERENCES";
export const SAVE_PREFERENCES = "SAVE_PREFERENCES";
export const HIDE_PREFERENCES = "HIDE_PREFERENCES";
export const EDIT_PREFERENCES = 'EDIT_PREFERENCES';

// restoring deleted orders
export const RESTORE_ORDER = 'RESTORE_ORDER';
export const ORDER_RESTORED = 'ORDER_RESTORED';
export const ORDER_NOT_RESTORED = 'ORDER_NOT_RESTORED';

// fetching key values
export const RECEIVE_KEY_VALUES = 'RECEIVE_KEY_VALUES';
export const REQUEST_KEY_VALUES = 'REQUEST_KEY_VALUES';
export const KEY_VALUES_FAILED = 'KEY_VALUES_FAILED';

//relax edits on order
export const REQUEST_RELAX_ORDER = 'REQUEST_RELAX_ORDER';
export const RECEIVE_RELAX_ORDER = 'RECEIVE_RELAX_ORDER';
export const RELAX_ORDER_FAILED = 'RELAX_ORDER_FAILED';

export const REQUEST_PUSH_SETTINGS = 'REQUEST PUSH SETTINGS';
export const RECEIVE_PUSH_SETTINGS = 'RECEIVE PUSH SETTINGS';

export const REQUEST_RESAVE = 'REQUEST_RESAVE';
export const RECEIVE_RESAVE = 'RECEIVE_RESAVE';

export const REQUEST_CLEAR_STUFF = 'REQUEST_CLEAR_STUFF';
export const RECEIVE_CLEAR_STUFF = 'RECEIVE_CLEAR_STUFF';

export const REQUEST_GEO_TYPE_QUERY = 'REQUEST_GEO_TYPE_QUERY';
export const RECEIVE_GEO_TYPE_QUERY = 'RECEIVE_GEO_TYPE_QUERY';

export const REQUEST_CACHE = 'REQUEST_CACHE';
export const RECEIVE_CACHE = 'RECEIVE_CACHE';
export const CACHE_FAILED = 'CACHE_FAILED';

export const REQUEST_BULK_PLACEMENTS = 'REQUEST_BULK';
export const RECEIVE_BULK_PLACEMENTS = 'RECEIVE_BULK';
export const BULK_PLACEMENTS_FAILED = 'BULK_PLACEMENTS_FAILED';

export const REQUEST_CLEAR_DELETE = 'REQUEST CLEAR_DELETE';
export const RECEIVE_CLEAR_DELETE = 'REQUEST CLEAR_DELETE';
